import { FactoringProvider, PROVIDER_FULL_LABELS, PROVIDER_SHORT_LABELS } from 'services/factoring'

export interface FactoringChipProvider {
    value: FactoringProvider
    label: string
    shortLabel: string
}

const provider = (value: FactoringProvider): FactoringChipProvider => ({
    value,
    label: PROVIDER_FULL_LABELS[value],
    shortLabel: PROVIDER_SHORT_LABELS[value],
})

/** Every provider that can appear on a load-detail factoring chip. */
export const FACTORING_CHIP_PROVIDERS: FactoringChipProvider[] = [
    provider(FactoringProvider.RTS),
    provider(FactoringProvider.TRIUMPH),
    provider(FactoringProvider.WEX),
    provider(FactoringProvider.WINFACTOR),
    provider(FactoringProvider.GSQUARED),
    provider(FactoringProvider.CAPITAL_DEPOT),
    provider(FactoringProvider.COMPASS),
    provider(FactoringProvider.TAFS),
    provider(FactoringProvider.ENGAGED_FINANCIAL),
    provider(FactoringProvider.HAUL_PAY),
    provider(FactoringProvider.OTR_SOLUTIONS),
    provider(FactoringProvider.FLEXENT),
    provider(FactoringProvider.BASICBLOCK),
    provider(FactoringProvider.ECAPITAL),
    // Outgo has no broker grade; the status segment uses the load's factorability flag.
    provider(FactoringProvider.OUTGO),
]
